import { Component, inject } from '@angular/core';
import { UserService } from '../../../../services/user/user.service';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-user-input',
    standalone: false,
    templateUrl: './user-input.component.html',
    styleUrl: './user-input.component.scss',
})
export class UserInputComponent extends InputComponent {
    private userService = inject(UserService);
    users$ = this.userService.getByType(this.field.dataFilter as any[]);
}
